module.exports = __webpack_public_path__ + "static/img/3.c5236ac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/8/eng/3.png
// module id = 69P8
// module chunks = 0